import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	exit: {
		id: 'project-directory-onboarding-modal.label.exit',
		defaultMessage: 'Exit',
		description: 'Label for pressing on the cross button of the modal',
	},
});
